import { JournalCountsEntity } from "../../entities/JournalEntity";
import { JournalRepository } from "../../repositories/JournalRepository";

export class GetJournalCountsUseCase {
  constructor(private repository: JournalRepository) {}

  async execute(params?: {
    date_from?: string;
    date_to?: string;
  }): Promise<JournalCountsEntity> {
    return await this.repository.fetchJournalCounts(params);
  }
}
